import { z } from 'zod';

export type ReportAuctionsForPeriodRequestFilter = {
    date_from?: string,
    date_to?: string,
};

export type ReportAuctionsForPeriodDownloadErrors = {
    date_from?: string[],
    date_to?: string[],
};

export const ReportAuctionsForPeriodDownloadErrorsSchema = z.object({
    date_from: z.string().array().optional(),
    date_to: z.string().array().optional(),
});
